import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable()
export class LocalStorageService {
  closeModalFilter: boolean;

  constructor(@Inject(PLATFORM_ID) private platformId: any) {
  }

  get length(): number {
    if (this.canUseLocalStorage()) {
      return localStorage.length;
    }
    return 0;
  }

  clear(): void {
    if (this.canUseLocalStorage()) {
      localStorage.clear();
    }
  }

  getItem(key: string): string | null {
    if (this.canUseLocalStorage()) {
      return localStorage.getItem(key);
    }
    return null;
  }

  key(index: number): string | null {
    if (this.canUseLocalStorage()) {
      return localStorage.key(index);
    }
    return null;
  }

  removeItem(key: string): void {
    if (this.canUseLocalStorage()) {
      localStorage.removeItem(key);
    }
  }

  setItem(key: string, value: string): void {
    if (this.canUseLocalStorage()) {
      localStorage.setItem(key, value);
    }
  }

  private canUseLocalStorage(): boolean {
    return !!(
      isPlatformBrowser(this.platformId) &&
      window &&
      window.localStorage
    );
  }
}
